import { render, staticRenderFns } from "./layout-component.vue?vue&type=template&id=3fa4f436&"
import script from "./layout-component.vue?vue&type=script&lang=ts&"
export * from "./layout-component.vue?vue&type=script&lang=ts&"
import style0 from "./layout-component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports